(() => {
  const init = () => {
    document
      .querySelectorAll(".collection__description[data-isoora-layout]:not([data-isoora-processed])")
      .forEach((root) => {
        root.setAttribute("data-isoora-processed", "1");

        const nodes = Array.from(root.childNodes).filter(
          (n) => !(n.nodeType === 3 && !n.textContent.trim())
        );

        const isHeading = (n) => n.nodeType === 1 && /^(H2|H3|H4)$/i.test(n.tagName);

        const blocks = [];
        let currentBlock = null;

        nodes.forEach((n) => {
          if (isHeading(n)) {
            currentBlock = document.createElement("div");
            currentBlock.className = "isoora-block w-full";

            const row = document.createElement("div");
            row.className = "isoora-row";

            const title = document.createElement("div");
            title.className = "isoora-title";
            title.appendChild(n.cloneNode(true));

            const text = document.createElement("div");
            text.className = "isoora-text";

            row.appendChild(title);
            row.appendChild(text);
            currentBlock.appendChild(row);
            blocks.push(currentBlock);
          } else if (currentBlock) {
            currentBlock.querySelector(".isoora-text").appendChild(n.cloneNode(true));
          }
        });

        root.innerHTML = "";
        const wrap = document.createElement("div");
        wrap.className = "isoora-blocks";

        blocks.forEach((b) => wrap.appendChild(b));
        root.appendChild(wrap);
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();


